import { useLocale } from "../i18n";
import type { ShipmentRecipient } from "./shipmentRecipient";

export function ShipmentRecipientDetails({ plan }: { plan?: ShipmentRecipient | null }) {
  const { w } = useLocale();
  if (!plan) return null;
  const address = plan.address;
  const phone = plan.telephone;
  return <section aria-label={w("بيانات المستلم المثبتة للشحنة", "Frozen shipment recipient")}>
    <h4>{w("بيانات المستلم عند إنشاء الشحنة", "Recipient when shipment was created")}</h4>
    {address && <><p>{[address.toName,address.attnName].filter(Boolean).join(" · ")}</p><address>{[address.address1,address.address2,address.city,address.stateProvinceGeoId,address.postalCode,address.countryGeoId].filter(Boolean).join("، ")}</address></>}
    {phone && <p>{w("هاتف المستلم", "Recipient phone")}: <bdi dir="ltr">{[phone.countryCode,phone.areaCode,phone.contactNumber].filter(Boolean).join(" ")}</bdi></p>}
    {plan.shippingInstructions && <p>{w("تعليمات التسليم", "Delivery instructions")}: {plan.shippingInstructions}</p>}
    {plan.isGift && <p>{w("هذه الشحنة هدية", "This shipment is a gift")}{plan.giftMessage ? ` · ${plan.giftMessage}` : ""}</p>}
  </section>;
}
